import { Directive, ElementRef, inject } from '@angular/core';

/**
 * Directive for projecting avatar or leading icon into a chip. Based on Angular Material MatChipAvatar pattern.
 *
 * @example
 *   ```html
 *   <harmony-chip label="User">
 *     <img hxChipAvatar src="avatar.jpg" alt="User avatar" />
 *   </harmony-chip>
 *   ```;
 */
@Directive({
  selector: 'img[hxChipAvatar], svg[hxChipAvatar], [hxChipAvatar]',
  standalone: true,
  host: {
    class: 'hx-chip-avatar',
    '[attr.role]': '"img"',
  },
})
export class HxChipAvatar {
  protected readonly _elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
}
